const vv_c = {
  VV_SECRET : 'VV_SECRET',
  VV_CLIENT_ID : 'VV_CLIENT_ID',
	VV_AUTHORITY : 'VV_AUTHORITY',
  VV_CALLBACK_URI : 'VV_CALLBACK_URI',
  VV_POST_LOGOUT_URI : 'VV_POST_LOGOUT_URI',
  VV_MATOMO_URL : "https://vaultvision.matomo.cloud/matomo.php?idsite=2&rec=1"
}

const redirectRequest = {
  redirect: 'http://localhost'
}

export {redirectRequest};
export default {vv_c};